export function hexToRgbChannels(hex: string): string {
  const value = hex.replace('#', '');
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(value.slice(i, i + 2), 16));
  return `${r}, ${g}, ${b}`;
}

export const withAlpha = (hex: string, alpha: number): string => `rgba(${hexToRgbChannels(hex)}, ${alpha})`;
